<template>
  <div class="recruitment-dashboard" :class="showAdd ? 'page-hide' : ''">
    <!-- 頂部標題欄 -->
    <div class="page-title u-flex">
      <div>
        <div class="page-title-main">學生管理</div>
        <div class="page-title-sub">權限領取管理</div>
      </div>
    </div>

    <div class="era-content-grid">
      <!-- 左侧排行榜 -->
      <section class="era-ranking-section">
        <div class="era-section-header">
          <div class="era-section-title u-flex page-filter-top align-start">
            <div class="u-flex" style="flex-grow: 1; align-items: flex-start">
              <div
                class="u-flex page-filter flex-wrap gap-10"
                style="flex-grow: 1"
              >
                <el-input
                  clearable
                  @blur="initData"
                  @keyup.enter.native="initData"
                  class="input-date input-date1"
                  v-model="search.keyword"
                  type="text"
                  placeholder="输入学生编号、邮箱、姓名或来源键"
                >
                </el-input>
                <el-input
                  clearable
                  @blur="initData"
                  @keyup.enter.native="initData"
                  class="input-date input-date1"
                  v-model="search.configId"
                  type="text"
                  placeholder="输入欢迎语配置编号"
                >
                </el-input>
                <el-select
                  @change="initData"
                  filterable
                  clearable
                  placeholder="状态"
                  class="input-date"
                  v-model="search.status"
                >
                  <el-option label="未回收" value="ACTIVE"></el-option>
                  <el-option label="已回收" value="REVOKED"></el-option>
                </el-select>
              </div>
              <!-- <div
                class="title-btn"
                style="margin-left: 10px; flex-shrink: 0"
                @click="downloadData"
              >
                下載
              </div> -->
            </div>
          </div>
        </div>

        <div class="era-table-container">
          <div class="ranking-table" style="margin-top: 0; min-width: 1000px">
            <div class="table-header">
              <span class="w3">學生Email</span>
              <span class="w2">來源鍵</span>
              <span class="w2">發放時間</span>
              <span class="w1">到期時間</span>
              <span class="w1">每日額度</span>
              <span class="wp5">狀態</span>
              <span class="fixed-col w2">操作</span>
            </div>
            <div
              class="table-row"
              v-for="(item, index) in dataList"
              :key="item.id"
            >
              <span class="w3">{{ item.studentEmail }}</span>
              <span class="w2">{{ item.sourceKey }}</span>
              <span class="w2">{{ item.grantTime }}</span>
              <span class="w1">{{ item.expireTime }}</span>
              <span class="w1">{{ item.dailyChatLimit }}/天</span>
              <span class="wp5">
                {{ item.status == "ACTIVE" ? "未回收" : "已回收" }}
              </span>
              <span class="item-btn fixed-col w2">
                <div class="btn btn-edit" @click="toSee(item)">查看</div>
                <div class="btn btn-edit" @click="toSee(item, 'update')">
                  修改
                </div>
                <div
                  class="btn btn-edit"
                  @click="toDelete(item)"
                  v-if="item.status === 'ACTIVE'"
                >
                  回收
                </div>
              </span>
            </div>
          </div>
        </div>
        <div
          class="era-search u-flex"
          style="justify-content: center; margin-top: 0.2rem"
        >
          <el-pagination
            @current-change="currentChange"
            background
            layout="prev, pager, next"
            :total="dataTotal"
          >
          </el-pagination>
        </div>
      </section>

      <div class="dialog-fixed-right" :class="showAdd ? 'show' : ''">
        <div class="dialog-fixed-modal" v-if="showAdd"></div>
        <div class="dialog-fixed-content">
          <div class="title" style="margin-top: 0.1rem">
            權限領取記錄詳情
            <span @click="showAdd = false">
              <i class="el-icon-close" style="font-size: 0.3rem"></i>
            </span>
          </div>
          <div>
            <div class="date-container">
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">權益領取記錄編號</label>
                <el-input
                  class="input-date"
                  v-model="post.id"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">學生編號</label>
                <el-input
                  class="input-date"
                  v-model="post.studentId"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">學生Email</label>
                <el-input
                  class="input-date"
                  v-model="post.studentEmail"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">學生姓名</label>
                <el-input
                  class="input-date"
                  v-model="post.studentName"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">歡迎語編號</label>
                <el-input
                  class="input-date"
                  v-model="post.configId"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">歡迎語來源鍵</label>
                <el-input
                  class="input-date"
                  v-model="post.sourceKey"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">發放時間</label>
                <el-input
                  class="input-date"
                  v-model="post.grantTime"
                  type="text"
                  :disabled="!isUpdate"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">到期時間</label>
                <el-input
                  class="input-date"
                  v-model="post.expireTime"
                  type="text"
                  :disabled="!isUpdate"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">每日聊天額度</label>
                <el-input
                  class="input-date"
                  v-model="post.dailyChatLimit"
                  type="text"
                  :disabled="!isUpdate"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">領取時新版聊天開關</label>
                <el-switch
                  class="input-date"
                  v-model="post.chatEnabled"
                  active-value="1"
                  inactive-value="0"
                  active-text="開啟"
                  inactive-text="關閉"
                  :disabled="!isUpdate"
                >
                </el-switch>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">領取時落點分析開關</label>
                <el-switch
                  class="input-date"
                  v-model="post.admissionAnalysisEnabled"
                  active-value="1"
                  inactive-value="0"
                  active-text="開啟"
                  inactive-text="關閉"
                  :disabled="!isUpdate"
                >
                </el-switch>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">領取時升學筆記開關</label>
                <el-switch
                  class="input-date"
                  v-model="post.studyNoteEnabled"
                  active-value="1"
                  inactive-value="0"
                  active-text="開啟"
                  inactive-text="關閉"
                  :disabled="!isUpdate"
                >
                </el-switch>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">狀態</label>
                <el-switch
                  class="input-date"
                  v-model="post.status"
                  active-value="REVOKED"
                  inactive-value="ACTIVE"
                  active-text="已回收"
                  inactive-text="未回收"
                  disabled
                >
                </el-switch>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">創建時間</label>
                <el-input
                  class="input-date"
                  v-model="post.createTime"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">更新時間</label>
                <el-input
                  class="input-date"
                  v-model="post.updateTime"
                  type="text"
                  disabled
                >
                </el-input>
              </div>
            </div>
          </div>
          <div class="dialog-footer" style="margin-top: 0.2rem">
            <el-button size="" v-if="isUpdate" @click="sureUpdate">
              確定修改
            </el-button>
            <el-button size="" v-else @click="showAdd = false">
              確定
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="溫馨提示"
      :visible.sync="dialogVisible"
      width="30%"
      style="align-items: center; justify-content: center"
      :center="true"
    >
      <span>
        確認要回收{{
          detailData.studentName || detailData.studentEmail
        }}的權益嗎？
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureDelete"> 确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiBaseUrl } from "../../api/config";
export default {
  components: {},
  data() {
    return {
      baseUrl: apiBaseUrl,
      page: 1,
      dataList: [],
      search: {
        keyword: "",
        configId: "",
        status: "",
        pageSize: 10,
      },
      showAdd: false,
      post: {
        id: "", //权益领取记录编号，也是回收参数 benefitRecordId；大整数可能返回字符串
        studentId: "", //学生编号；大整数可能以字符串返回，客户端应按字符串保存
        studentEmail: "", //学生邮箱
        studentName: "", //学生姓名
        configId: "", //发放权益的欢迎语配置编号
        sourceKey: "", //发放时命中的欢迎语来源键
        grantTime: "", //发放时间，台北时间，格式 yyyy-MM-dd HH:mm:ss
        expireTime: "", //到期时间，台北时间，格式 yyyy-MM-dd HH:mm:ss
        dailyChatLimit: "", //发放时保存的每日聊天额度
        chatEnabled: "", //领取时的新版聊天开关：0 关闭，1 开启
        admissionAnalysisEnabled: "", //领取时的落点分析开关：0 关闭，1 开启
        studyNoteEnabled: "", //领取时的升学笔记开关：0 关闭，1 开启
        status: "", //存储状态：ACTIVE 未回收，REVOKED 已回收；是否到期还需结合 expireTime 判断
        createTime: "", //记录创建时间，格式 yyyy-MM-dd HH:mm:ss
        updateTime: "", //记录更新时间，格式 yyyy-MM-dd HH:mm:ss。
      },
      offlineSubscription: {
        merchantTradeNo: "", //全局唯一业务订单号，最长 32 位
        planId: "", //已启用套餐 ID
        paidAmount: "", //实收金额，大于 0，最多两位小数
        discountReason: "", //实收金额与套餐售价不一致时必填，最多 200 字
        paidTime: "", //	ISO-8601 LocalDateTime，例如 2026-10-09T10:00:00
        paymentMethod: "", //OFFLINE_BANK、OFFLINE_CASH 或 OFFLINE_TRANSFER
        invoiceRequired: true, //是否开票，默认 true
        invoiceEmail: "", //发票收件邮箱
        invoiceType: "", //B2C 或 B2B 发票类型
        invoiceNo: "", //纸本发票号码
        paymentRemark: "", //付款备注
        invoiceBuyer: {
          customerIdentifier: "", //B2B 时必填	8 位数字统一编号
          customerName: "", //	B2B 时必填	买方名称
          customerAddr: "", //	买方地址
          carrierType: "", //	载具类型
          carrierNum: "", //	载具号码
        },
      },
      dialogVisible: false,
      detailData: {},
      sys_area: [],
      dataTotal: 0,
      showMoreInput: false,
      plans: [],
      studentStageList: [],
      isUpdate: false,
    };
  },
  mounted() {
    this.initData();
    this.$axios
      .post("rest-api/system/app/common/dict-data/list", {
        dictType: "sys_area",
      })
      .then((res) => {
        this.sys_area = res.data;
      });
    this.$axios
      .get("rest-api/member/app/subscription/plans", {})
      .then((res) => {
        this.plans = res.data;
      });
    this.$axios
      .post("rest-api/system/app/common/dict-data/list", {
        dictType: "student_stage",
      })
      .then((res) => {
        this.studentStageList = res.data;
      });
  },
  methods: {
    toSee(item, type = "") {
      const that = this;
      that.isUpdate = type === "update";
      that.$axios
        .post("rest-api/member/app/chatWelcome/benefitRecord/detail", {
          id: item.id,
        })
        .then((res) => {
          that.post = {
            ...that.post,
            ...res.data,
          };
          that.showAdd = true;
        })
        .catch((err) => {});
    },
    toDelete(item) {
      this.detailData = item;
      this.dialogVisible = true;
    },
    sureDelete() {
      const that = this;

      that.$axios
        .post("rest-api/member/app/chatWelcome/benefitRecord/revoke", {
          benefitRecordId: that.detailData.id,
        })
        .then((res) => {
          that.initData();
          that.dialogVisible = false;
          that.$message({
            message: "操作成功",
            type: "success",
          });
        })
        .catch((err) => {});
    },
    downloadData() {
      const blob = new Blob([this.dataList], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `權益領取記錄_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
    },
    currentChange(e) {
      this.page = e;
      this.getList();
    },
    initData() {
      this.page = 1;
      this.getList();
    },
    getList() {
      const that = this;
      that.$axios
        .post("rest-api/member/app/chatWelcome/benefitRecord/page", {
          pageNum: that.page,
          ...that.search,
        })
        .then((res) => {
          that.dataList = res.data.list;
          that.dataTotal = res.data.total;
        })
        .catch((err) => {});
    },

    sureUpdate() {
      this.$axios
        .post(
          "rest-api/member/app/chatWelcome/benefitRecord/edit",
          JSON.stringify({
            id: this.post.id,
            grantTime: this.post.grantTime,
            expireTime: this.post.expireTime,
            dailyChatLimit: this.post.dailyChatLimit,
            chatEnabled: this.post.chatEnabled,
            admissionAnalysisEnabled: this.post.admissionAnalysisEnabled,
            studyNoteEnabled: this.post.studyNoteEnabled,
          }),
        )
        .then((res) => {
          this.initData();
          this.showAdd = false;
          this.$message({
            message: "操作成功",
            type: "success",
          });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.recruitment-dashboard {
  min-height: 100vh;
  background: #eef3f6;
  padding: 0.2rem;
}

/* 頂部標題欄 */
.dashboard-header {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
}

.help-btn {
  background: #4a5568;
  color: white;
  border: none;
  padding: 0.08rem 0.2rem;
  border-radius: 0.06rem;
  font-size: 0.2rem;
  cursor: pointer;
}

/* 日期選擇區域 */
.date-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
}

.date-container {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
}

.date-input-group {
  width: 32%;
  min-width: 32%;
  margin-right: 1%;
  margin-bottom: 0.2rem;
}

.date-label {
  display: flex;
  align-items: center;
  margin-bottom: 0.08rem;
  color: #222;
  font-size: 0.18rem;
}

.date-input {
  background: #91a2a41a;
  border: 0.01rem solid #91a2a480;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  padding: 0.12rem 0.1rem;
  color: #999;
}

/* 核心數據指標 */
.kpi-section {
  flex: 1;
  margin-right: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.section-title {
  font-weight: bold;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  color: #2d3748;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1.8rem, 1fr));
  gap: 0.2rem;
}

.kpi-card {
  background: white;
  position: relative;
  border-radius: 0.12rem;
  padding: 0.25rem;
  box-shadow: 0.04rem 0.04rem 0.2rem 0rem #27545726;

  .ic-block {
    width: 0.5rem;
    height: 0.5rem;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
  }
}

.kpi-header {
  margin-bottom: 00.17rem;
}

.kpi-name {
  font-size: 0.18rem;
  color: #777;
}

.kpi-value {
  font-size: 0.32rem;
  color: #000;
  margin-bottom: 0.4rem;
}

.kpi-comparison {
  display: flex;
  align-items: center;
  gap: 0.06rem;
  font-size: 0.12rem;
}

.kpi-comparison.positive {
  color: #21c93a;
}

.trend-icon {
  font-weight: bold;
}

/* 主要內容區域 */
.main-content {
  flex: 1;
  margin-left: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
}

/* 排行榜樣式 */
.ranking-section {
  flex: 1;
  margin-left: 0.1rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.ranking-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;
}

.ranking-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

.ranking-table {
  border: 0.01rem solid #27545726;
  border-radius: 0.1rem;
  margin-top: 0.2rem;
  overflow: hidden;
}

.ranking-date {
  color: #718096;
  font-size: 0.2rem;
}

.ranking-subtitle {
  color: #718096;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
}

.table-header {
  display: flex;
  padding: 0.12rem 0;
  border-bottom: 0.01rem solid #e2e8f0;
  background: #0ba29b0f;
  color: #4a5568;
  font-size: 0.18rem;
}

.table-header span {
  flex-grow: 1;
  flex-shrink: 1;
  text-align: center;
}

.table-row span {
  flex-grow: 1;
  flex-shrink: 1;
  word-break: break-all;
  text-align: center;
}
span.w1 {
  width: 10%;
}
span.w2 {
  width: 20%;
}
span.w3 {
  width: 30%;
}
span.wp5 {
  width: 5%;
}
.table-row {
  display: flex;
  padding: 0.12rem 0;
  font-size: 0.18rem;
  border-bottom: 0.01rem solid #e2e8f0;
}

.rank {
  color: #4a5568;
}

.department {
  color: #2d3748;
}

.area,
.rate {
  text-align: right;
  color: #4a5568;
}

/* 篩選區域樣式 */
.filter-section {
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  gap: 0.1rem;
  margin-bottom: 0.2rem;
}

.filter-btn {
  flex: 1;
  padding: 0.1rem;
  border: 0.01rem solid #e2e8f0;
  background: #f7fafc;
  border-radius: 0.08rem;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.primary-btn {
  width: 100%;
  padding: 0.12rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  cursor: pointer;
  margin-bottom: 0.2rem;
}

.dropdown {
  width: 100%;
  padding: 0.12rem;
  border: 0.01rem solid #e2e8f0;
  border-radius: 0.08rem;
  background: white;
  margin-bottom: 0.2rem;
}

.stats-info {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.stat-item {
  padding: 0.1rem;
  background: #f7fafc;
  border-radius: 0.06rem;
  text-align: center;
  color: #718096;
  font-size: 0.2rem;
}

/* 響應式設計 */
@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }
}

@media (max-width: 768px) {
  .recruitment-dashboard {
    padding: 0.1rem;
  }

  .header-content {
    flex-direction: column;
    gap: 00.17rem;
    align-items: flex-start;
  }

  .date-container {
    flex-direction: column;
    gap: 00.17rem;
  }

  .kpi-grid {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.5rem 1fr 0.8rem 0.7rem;
    gap: 0.1rem;
    font-size: 0.2rem;
  }

  .filter-group {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .kpi-value {
    font-size: 0.24rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.4rem 1fr 0.7rem 0.6rem;
    gap: 0.08rem;
  }

  .ranking-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.1rem;
  }
}

.search-title {
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 0.28rem;
}

.modle-block2 {
  display: flex;
}

@media (max-width: 1024px) {
  .modle-block2 {
    display: block;
  }

  .kpi-section {
    margin-right: 0;
  }

  .ranking-section {
    margin-left: 0;
  }
}

/* 页面标题 */
.era-header {
  margin-bottom: 0.3rem;
}

.era-main-title {
  font-size: 0.28rem;
  font-weight: 700;
  color: #2d3748;
  text-align: center;
}

/* 内容网格布局 */
.era-content-grid {
  display: grid;
  // grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
  margin: 0 auto;
}

/* 排行榜区域 */
.era-section-header {
  margin: 0 0 0.2rem;
}

.era-section-title {
  font-weight: bold;
  color: #2d3748;
  justify-content: space-between;

  .title-btn {
    background: #0ba29b;
    padding: 0.12rem;
    border-radius: 0.06rem;
    color: #fff;
    cursor: pointer;
    font-size: 0.2rem;
  }

  .tips {
    font-weight: normal;
    font-size: 0.12rem;
    color: #ed6d00;
    margin-left: 0.3rem;
  }

  img {
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.06rem;
  }
}

.era-section-title-sub {
  font-size: 00.17rem;
  font-weight: bold;
  color: #0ba29b;
  margin-bottom: 0.2rem;
  margin-top: 0.2rem;
}

/* 表格样式 */
.era-table-container {
  overflow-x: auto;
}

.era-ranking-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.2rem;
}

.era-ranking-table th {
  background: #f8fafc;
  padding: 0.12rem 0.08rem;
  text-align: left;
  font-weight: bold;
  color: #4a5568;
  border-bottom: 0.02rem solid #e2e8f0;
}

.era-ranking-table td {
  padding: 0.12rem 0.08rem;
  border-bottom: 0.01rem solid #e2e8f0;
  color: #4a5568;
}

.era-ranking-table .era-highlight-row {
  background: #fffaf0;
}

.era-ranking-table .era-highlight-row td {
  font-weight: 500;
}

.era-rank-col {
  width: 0.6rem;
}

.era-name-col {
  min-width: 2rem;
}

.era-private-col {
  width: 1.2rem;
}

.era-growth-col {
  width: 1rem;
}

.era-school-col {
  width: 1.4rem;
}

.era-rank-cell {
  text-align: center;
}

.era-rank-number {
  display: inline-block;
  width: 0.28rem;
  height: 0.28rem;
  line-height: 0.28rem;
  text-align: center;
  background: #667eea;
  color: white;
  border-radius: 50%;
  font-size: 0.12rem;
  font-weight: bold;
}

.era-ranking-table .era-highlight-row .era-rank-number {
  background: #ed8936;
}

.era-name-cell {
  color: #2d3748;
  font-weight: 500;
}

.era-growth-cell {
  text-align: center;
}

.era-growth-rate.era-positive {
  color: #48bb78;
  font-weight: bold;
}

.era-school-cell {
  text-align: right;
}

/* 右侧数据面板 */
.era-stats-panel {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.4rem;
}

.era-chart-section,
.era-quality-section {
  background: #eef6f685;
  border-radius: 00.17rem;
  padding: 0 00.17rem 00.17rem;
}

.era-chart-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

/* 管道列表 */
.era-channel-list {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-channel-item {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.08rem 0;
}

.era-channel-dot {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
}

.era-channel-dot.era-organic {
  background: #48bb78;
}

.era-channel-dot.era-referral {
  background: #ed8936;
}

.era-channel-dot.era-social {
  background: #9f7aea;
}

.era-channel-dot.era-paid {
  background: #4299e1;
}

.era-channel-dot.era-direct {
  background: #f56565;
}

.era-channel-name {
  color: #4a5568;
  font-size: 0.2rem;
}

/* 品质评比表格 */
.era-quality-table {
  display: flex;
  flex-direction: column;
  gap: 00.17rem;
}

.era-table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  padding-bottom: 0.1rem;
  border-bottom: 0.02rem solid #e2e8f0;
  font-weight: bold;
  color: #4a5568;
  font-size: 0.12rem;
}

.era-table-body {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  align-items: center;
}

.era-channel-cell {
  font-size: 0.12rem;
  color: #4a5568;
  font-weight: 500;
}

.era-progress-cell {
  position: relative;
}

.era-progress-bar {
  position: relative;
  height: 0.24rem;
  background: #f7fafc;
  border-radius: 0.12rem;
  overflow: hidden;
}

.era-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 0.12rem;
  transition: width 0.3s ease;
}

.era-progress-fill.era-depth-fill {
  background: linear-gradient(90deg, #48bb78, #38a169);
}

.era-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.11rem;
  font-weight: bold;
  color: #2d3748;
  z-index: 1;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .era-content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }

  .era-stats-panel {
    flex-direction: row;
  }

  .era-stats-panel {
    padding-top: 0;
  }

  .era-chart-section,
  .era-quality-section {
    flex: 1;
  }

  .page-title {
    display: block;

    .page-title-btn {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
    }
  }
}

@media (max-width: 768px) {
  .date-input-group {
    width: 100%;
    min-width: 100%;
    margin: 0;
  }

  .dialog-account {
    width: 90% !important;
  }

  .era-container {
    padding: 00.17rem;
  }

  .era-section-title {
    .tips {
      margin-left: 0;
      margin-top: 00.17rem;
    }
  }

  .era-main-title {
    font-size: 0.22rem;
  }

  .era-content-grid {
    gap: 00.17rem;
  }

  .era-stats-panel {
    flex-direction: column;
  }

  .era-ranking-table {
    font-size: 0.12rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.08rem 0.06rem;
  }

  .era-name-col {
    min-width: 1.5rem;
  }

  .era-private-col {
    width: 1rem;
  }

  .era-growth-col {
    width: 0.8rem;
  }

  .era-school-col {
    width: 1.2rem;
  }
}

@media (max-width: 480px) {
  .era-container {
    padding: 0.1rem;
  }

  .era-main-title {
    font-size: 0.2rem;
  }

  .era-ranking-table {
    font-size: 0.11rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.06rem 0.04rem;
  }

  .era-table-header,
  .era-table-row {
    grid-template-columns: 1fr 1fr;
    gap: 0.1rem;
  }

  .era-table-header .era-depth-header,
  .era-table-row .era-progress-cell:last-child {
    display: none;
  }

  .era-rank-number {
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    font-size: 0.11rem;
  }
}

.era-content-grid {
  margin-top: 0.2rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.08);
}

.page-title {
  justify-content: space-between;
  margin: 0 0 0.3rem;

  .page-title-main {
    font-size: 0.26rem;
    font-weight: bold;
  }

  .page-title-sub {
    color: #0ba29b;
    font-size: 0.22rem;
    font-weight: bold;
    margin-top: 0.12rem;
  }
}

.module-show {
  background: #ed6d001a;
  color: #ed6d00;
  font: size 0.2rem;
  padding: 0.2rem;
  margin-top: 0.3rem;
}

.tips1 {
  background: #ed6d001a;
  border-radius: 16px;
  font-size: 0.12rem;
  color: #ed6d00;
  padding: 0.08rem 0.2rem;
}

.item-btn {
  display: flex;
  justify-content: center;

  .btn {
    cursor: pointer;
    padding: 0 0.05rem;
  }

  .btn-edit {
    color: #0ba29b;
  }

  .btn-del {
    color: #ff383c;
  }
}

.module-count {
  background: #f3f3f3;
  border: 1px dashed #275457;
  border-radius: 10px;
  padding: 0.3rem 0.24rem;

  .module-header {
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }
}

.btn-add {
  background: #0ba29b;
  padding: 0.12rem;
  border-radius: 0.06rem;
  color: #fff;
  font-size: 0.2rem;
  margin-top: 0.2rem;
}

.input-tips {
  font-size: 0.12rem;
  color: #999;
}

.title {
  font-size: 0.2rem;
  color: #222;
  margin-top: 0.24rem;
  margin-bottom: 0.24rem;
  display: flex;
  justify-content: space-between;
}

.dialog-account {
  width: 8rem;
  margin: 0 auto;

  ::v-deep .el-dialog {
    width: 100% !important;
    overflow: auto;
  }
}

.module-role {
  border-top: 1px dashed #e1e1e1;
  padding-top: 0.3rem;
  margin-top: 0.3rem;
}

.module-contract-add {
  position: fixed;
  top: 0;
  right: -100%;
  opacity: 0;
  transition: 0.5s ease-in-out;
  width: 30%;
  z-index: 100;
  bottom: 0;
  display: block;
  background-color: #f7f8fc;
  padding: 0.2rem;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.2);
}

.module-contract-add .date-input-group {
  width: 100%;
  min-width: 100%;
  margin: 0 0 0.2rem;
}

.module-contract-add.show {
  opacity: 1;
  right: 0;
}

.contract-list {
  .item {
    margin-bottom: 0.24rem;
  }

  .item-date {
    font-size: 0.14rem;
    font-weight: bold;
  }

  .item-content {
    border: 1px solid #949baa4d;
    border-radius: 5px;
    padding: 0.06rem 0.12rem;
    margin-top: 0.1rem;
  }

  .item-show {
    font-size: 0.14rem;
    display: flex;
    justify-content: space-between;
    padding: 0.06rem;
  }
}

@media (max-width: 1024px) {
  .module-contract-add {
    width: 90%;
  }

  .module-contract-add .date-input-group {
    margin: 0;
  }
}
.page-filter .input-date {
  width: 22.5% !important;
}
.avatar-uploader {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  height: 0.4rem;
  width: 0.4rem;
}
</style>
